const env = process.env.NODE_ENV
const isProd = env === 'production'

export const baseApiUrl = isProd ? 'https://cc.uoiquality.com/api/' : 'http://localhost:6025/api/'
export const uploaderUrl = isProd ? 'https://cc.uoiquality.com/upload/' : 'http://localhost:6027/'